<template>
    <div class="layout" id="app">
        <el-container v-if="user.token" class="container">
            <el-aside class="aside">
                <div class="head">
                    <div>
                    <!--<span><el-button @click="toHome" bg="false">游戏管理平台</el-button></span>-->
                    <el-menu background-color="#222832" text-color="#fff" active-text-color="#fff" :router="true">
                        <el-menu-item index="/stats/home">游戏管理平台</el-menu-item>
                    </el-menu>
                    </div>
                </div>
                <div class="line" />
                <el-menu :unique-opened="true" :default-openeds="['1']" background-color="#222832" text-color="#fff" :router="true">
                    <el-sub-menu v-for="(config, index) in list" :key="index" :index="index + 1 + ''">
                        <template #title>
                            <span>{{config.name}}</span>
                        </template>
                        <el-menu-item-group>
                            <el-menu-item v-for="(sub_config, sub_index) in config.list" :key="sub_index" :index="sub_config.route">{{sub_config.name}}</el-menu-item>
                        </el-menu-item-group>
                    </el-sub-menu>
                </el-menu>
            </el-aside>
			<el-container class="content">
				<el-header><Header /></el-header>
				<el-main>
					<div class="main">
						<router-view />
					</div>
				</el-main>
				<el-footer><Footer /></el-footer>
			</el-container>
		</el-container>
		<el-container v-else class="container">
			<el-container class="content">
				<el-main>
					<Login />
				</el-main>
				<el-footer><Footer /></el-footer>
			</el-container>
		</el-container>
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import Login from '@/views/login/index.vue'
import axios from '@/utils/axios'
import {user} from '@/utils/index'

export default {
    name: 'App',
    components: {
        Header,
        Footer,
		Login,
    },
    data() {
        let {configList} = user.init(axios, this);
        return {
			user,
            list: configList,
        }
    },
	methods: {
        reloadLogin: function () {
            location.reload();
        },
        toHome: function () {
            this.$router.push({name: 'stats_home'});
        }
	}
}
</script>

<style>
#app {
	font-family: Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;
	margin-top: 0;
}

.el-row {
    margin-bottom: 20px;
}
.el-row:last-child {
    margin-bottom: 0;
}
.el-col {
    border-radius: 4px;
}
</style>

<style scoped>
.layout {
    height: 100vh;
    background-color: #ffffff;
}
.container {
    height: 100vh;
}
.aside {
    width: 200px;
    background-color: #222832;
    overflow: hidden;
    overflow-y: auto;
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
}
.aside::-webkit-scrollbar {
    display: none;
}
.head {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
}
.head > div {
    display: flex;
    align-items: center;
}

.head img {
    width: 50px;
    height: 50px;
    margin-right: 10px;
}
.head span {
    font-size: 20px;
    color: #ffffff;
}
.line {
    border-top: 1px solid hsla(0,0%,100%,.05);
    border-bottom: 1px solid rgba(0,0,0,.2);
}
.content {
    display: flex;
    flex-direction: column;
    max-height: 100vh;
    overflow: hidden;
}
.main {
    height: auto;
    overflow: auto;
    padding: 10px;
}
</style>

<style>
body {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
}
.el-menu {
    border-right: none!important;
}
.el-sub-menu {
    border-top: 1px solid hsla(0, 0%, 100%, .05);
    border-bottom: 1px solid rgba(0, 0, 0, .2);
}
.el-sub-menu:first-child {
    border-top: none;
}
.el-sub-menu [class^="el-icon-"] {
    vertical-align: -1px!important;
}
a {
    color: #409eff;
    text-decoration: none;
}
.el-pagination {
    text-align: center;
    margin-top: 20px;
}
.el-popper__arrow {
    display: none;
}
</style>
